import React from "react";

import { Order } from "@models/Order";
import { OrderSet } from "@models/OrderSet";

import { ExtendedOrderSetVariant } from "./combineOrderSetAndOrdersQuery";

export type onOrderSetDelete = (orderSet: OrderSet) => void;

export type OrderSetContextType = {
  orderSet: OrderSet;
  orders: Order[];
  orderSetVariants: ExtendedOrderSetVariant[];
  orderSetSpendPerBudget: Record<string, number>;
  orderSetSpendPerBudgetCoop: Record<string, number>;
  orderSetId: string;
  isFetching: boolean;
  isCoopOrderSet: boolean;
  onOrderSetDelete: onOrderSetDelete;
};

export const CurrentOrderSetContext =
  React.createContext<OrderSetContextType | null>(null);

export const useCurrentOrderSet = () => {
  const context = React.useContext(CurrentOrderSetContext);

  if (!context) {
    throw new Error(
      "useCurrentOrderSet must be used within a CurrentOrderSetProvider"
    );
  }

  return context;
};

export const useOptionalCurrentOrderSet = () => {
  return React.useContext(CurrentOrderSetContext);
};
